
			(async function () {
				await window.__onOEMReady; // guarantees window.__OEM_CONFIG__ exists
				console.log('Config Ready');

				// Initialize Intercom settings
				const cfg = window.__OEM_CONFIG__;
				window.intercomSettings = {
					api_base: 'https://api-iam.intercom.io',
					alignment: 'left',
					app_id: 'f1a94cfb',
					ekho_app: 'Checkout',
					account_type: 'vehicle buyer',
					hide_default_launcher: true,
					program_owner_id: cfg.programOwnerId,
				};

				// Initialize Intercom and wait for it to be ready
				await new Promise((resolve) => {
					var w = window;
					var ic = w.Intercom;
					if (typeof ic === 'function') {
						ic('reattach_activator');
						ic('update', w.intercomSettings);
						resolve();
					} else {
						var d = document;
						var i = function () {
							i.c(arguments);
						};
						i.q = [];
						i.c = function (args) {
							i.q.push(args);
						};
						w.Intercom = i;
						var l = function () {
							var s = d.createElement('script');
							s.type = 'text/javascript';
							s.async = true;
							s.src = 'https://widget.intercom.io/widget/f1a94cfb';
							s.onload = resolve; // Resolve when Intercom script loads
							var x = d.getElementsByTagName('script')[0];
							x.parentNode.insertBefore(s, x);
						};
						if (document.readyState === 'complete') {
							l();
						} else if (w.attachEvent) {
							w.attachEvent('onload', l);
						} else {
							w.addEventListener('load', l, false);
						}
					}
				});

				// Now start the app
				await import('/src/main.tsx'); // your current entry
			})();
		